function getNonBlankString(value) {
  if (value === null || value === undefined) return '';
  const stringValue = String(value).trim();
  return stringValue;
}

export function getResourceNameWithFallback({
  currentName,
  connectionType,
  metaInfo,
  credential,
  resourceLabel,
}) {
  if (getNonBlankString(currentName)) return currentName;

  const connectorName =
    getNonBlankString(metaInfo?.displayName) ||
    getNonBlankString(metaInfo?.name) ||
    getNonBlankString(connectionType);
  const credentialName = getNonBlankString(credential?.name);

  if (connectorName && credentialName) {
    return `${connectorName} - ${credentialName}`;
  }

  return connectorName || resourceLabel;
}
